// Чистые функции просмотрщика (без React и three.js): проверяются обычными тестами.

// Схема зубов: верхний ряд слева направо на экране — 18…11 | 21…28, нижний — 48…41 | 31…38 (правая сторона пациента слева).
export const TOOTH_ROWS = [
  [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28],
  [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38],
];

/** Чёрный или белый текст — что читается на фоне заданного цвета #rrggbb. */
export const readableOn = (hex) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ''));
  if (!m) return '#000000';
  const n = parseInt(m[1], 16);
  const lum = (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  return lum > 0.55 ? '#000000' : '#ffffff';
};

/**
 * Группы в порядке: сначала описанные в `groups`, затем остальные, встреченные у моделей.
 * Возвращает [{key, label, items}], пустые группы пропускаются.
 */
export const buildGroups = (items, groups = {}) => {
  const order = Object.keys(groups);
  items.forEach((it) => { if (!order.includes(it.group)) order.push(it.group); });
  return order
    .map((key) => ({
      key, label: groups[key]?.label || key, items: items.filter((it) => it.group === key),
      opacity: groups[key]?.opacity, hidden: !!groups[key]?.hidden,
    }))
    .filter((g) => g.items.length > 0);
};

/** Группа рисуется схемой зубов, если у всех её моделей есть номер зуба FDI. */
export const isToothGroup = (group) => group.items.length > 1 && group.items.every((it) => Number.isInteger(it.fdi));

/** Квантование прозрачности слайдера: 0.05…1. */
export const clampOpacity = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? Math.min(1, Math.max(0.05, n)) : 1;
};

/** Палитра для моделей, загруженных пользователем: цвета различимы между собой. */
export const MODEL_PALETTE = ['#4ecdc4', '#ff6b6b', '#ffd166', '#06d6a0', '#118ab2', '#c77dff', '#f78c6b', '#a0c4ff', '#b5e48c', '#ff99c8'];
export const paletteColor = (index) => MODEL_PALETTE[((index % MODEL_PALETTE.length) + MODEL_PALETTE.length) % MODEL_PALETTE.length];
